import { useCallback } from "react"


export const useExportData = () => {


  const loadExportData = useCallback((schema, data) => {

    let tableData = []
    for (let i in schema.properties) {

      for (let r in schema.properties[i].export_rows) {

        let tableRow = {
          "name": i,
          "type": schema.properties[i].type,
          "ais_upload": schema.properties[i].ais_upload,

          "minimum": schema.properties[i].minimum,
          "maximum": schema.properties[i].maximum,
          "decimal_places": schema.properties[i].decimal_places,
          "maxLength": schema.properties[i].maxLength,

          "analyte": schema.properties[i].export_rows[r].prop_analyte,
          "kv": schema.properties[i].export_rows[r].prop_kv,
          "sample": schema.properties[i].export_rows[r].prop_sample ? schema.properties[i].export_rows[r].prop_sample : [],
          "measure": schema.properties[i].export_rows[r].prop_measure,


          "value": "-",
        }
        if (r > 0) {
          tableRow.additional_export_row = true
        } 

        tableData.push(tableRow);
      }
    }

    for (let i in schema.eas_static_rows) {
      let tableRow = {
        "eas_static_row": true,

        "name": "—",
        "ais_upload": true,

        "analyte": schema.eas_static_rows[i].prop_analyte,
        "kv": schema.eas_static_rows[i].prop_kv,
        "sample": schema.eas_static_rows[i].prop_sample ? schema.eas_static_rows[i].prop_sample : [],
        "measure": schema.eas_static_rows[i].prop_measure,

        "value": schema.eas_static_rows[i].prop_value,
      }      
    
      tableData.push(tableRow)
    }

    return tableData;
  }, [])


  const generateSchemafromTable = useCallback((schema, tableData) => {
    const newSchema = JSON.parse(JSON.stringify(schema));
    delete newSchema.properties;
    newSchema.properties = {};
    
    delete newSchema.eas_static_rows;
    newSchema.eas_static_rows = [];

    for (let i in tableData) {

      if (tableData[i].eas_static_row !== true) {

        // если это единственный или первый ряд в таблице экспорта, который соотвествует полю формы.   
        if (!(tableData[i].name in newSchema.properties)) {

          let props = {
            "type": tableData[i].type,
            "ais_upload": tableData[i].ais_upload,

            //"prop_analyte": tableData[i].analyte,
            //"prop_kv": tableData[i].kv,
            //"prop_measure": tableData[i].measure,
          }

          if (tableData[i].maximum) {
            if (tableData[i].type === 'integer') {
              props.maximum = parseInt(tableData[i].maximum)
            }
            if (tableData[i].type === 'number') {
              props.maximum = Number(tableData[i].maximum)
            }
          }

          if (tableData[i].minimum) {
            if (tableData[i].type === 'integer') {
              props.minimum = parseInt(tableData[i].minimum)
            }
            if (tableData[i].type === 'number') {
              props.minimum = Number(tableData[i].minimum)
            }
          }      

          if (tableData[i].type === 'number') {
            props.decimal_places = tableData[i].decimal_places
          }

          if (tableData[i].type === 'string') {
            props.maxLength = tableData[i].maxLength
          }

          props.export_rows = [
            {
              "prop_analyte": tableData[i].analyte,
              "prop_sample": tableData[i].sample,
              "prop_measure": tableData[i].measure,
              "prop_kv": tableData[i].kv,
            }
          ]

          newSchema.properties[tableData[i].name] = props

        } else 
        // если это не первый и не едиснтвенный ряд в таблице, который соотвествует полю формы, мы лишь добавим дополнительный объект в export_rows  
        {
          let anotherExportRow = {
              "prop_analyte": tableData[i].analyte,
              "prop_sample": tableData[i].sample,
              "prop_measure": tableData[i].measure,
              "prop_kv": tableData[i].kv,
            }

          newSchema.properties[tableData[i].name].export_rows.push(anotherExportRow)
        }
      } else {

        let props = {
          "prop_analyte": tableData[i].analyte,
          "prop_sample": tableData[i].sample,
          "prop_measure": tableData[i].measure,
          "prop_kv": tableData[i].kv,

          "prop_value": tableData[i].value,
        }

        newSchema.eas_static_rows.push(props)
      }
      
    }

    return newSchema;
  }, [])


  return { 
    loadExportData,
    generateSchemafromTable 
  }

}